import React, { useEffect, useRef, useState } from 'react';
import productService from "../Services/productService";
import Pagination from "../Components/Pagination";
import Loading from '../Modals/Loading';

const Products = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState([]);
    const [isAllLoaded, setIsAllLoaded] = useState(false);

    const isInitialRender = useRef(true);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = products.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(products.length / itemsPerPage);

    const fetchProducts = async (loadAll = false) => {
    try {
        setLoading(true);
        const response = await productService.fetchAll();
        const fetchedProducts = response.products;
        setProducts(loadAll ? fetchedProducts : fetchedProducts.slice(0, 50));
        setIsAllLoaded(loadAll);
        setLoading(false);
    } catch (err) {
        console.log(err);
    }
};

    useEffect(() => {
    fetchProducts();
}, []);


    return (
        <div className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
            <div className="flex flex-col">
                <div className='flex flex-row justify-between'>
                    <p className='font-bold text-3xl text-secondary'>Products</p>
                    {!loading && (
                        <div className="mb-4">
                            <button
                                onClick={() => fetchProducts(true)}
                                className="button-primary"
                            >
                                Load All Data
                            </button>
                        </div>
                    )}
                </div>
                {loading ? (
                    <Loading />
                ) : (
                    <div className="table-div">
                        <table>
                            <thead>
                                <tr className=" border-y-2 text-left w-full text-black text-[10px]">
                                    <th className="rounded-tl-lg py-4 w-[2%] pl-4">Id</th>
                                    <th className="py-4 w-[2%]">Brand</th>
                                    <th className="py-4 w-[2%]">Name</th>
                                    <th className="py-4 w-[2%]">Part No.</th>
                                    <th className="py-4 w-[2%]">Qty</th>
                                    <th className="py-4 w-[2%]">Weight</th>
                                    <th className="py-4 w-[2%]">Delivery</th>
                                    <th className="py-4 w-[2%]">Supplier</th>
                                    <th className="rounded-tr-lg py-4 w-[2%]">Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.map((item, index) => (
                                    <tr key={index} className="bg-accent border-b border-gray-100 text-left">
                                        <td className="py-4 font-bold text-blue-600 w-[2%] pl-4">{item.id}.</td>
                                        <td className="py-4 font-bold w-[2%]">{item.vendor_code}</td>
                                        <td className="py-4 w-[4%]">{item.title}</td>
                                        <td className="py-4 w-[4%]">{item.brand}</td>
                                        <td className="py-4 w-[2%]">{item.quantity}</td>
                                        <td className="py-4 w-[3%]">{item.weight}</td>
                                        <td className="py-4 w-[3%]">{item.delivery}</td>
                                        <td className="py-4 w-[3%]">{item.supplier_code}</td>
                                        <td className="py-4 w-[3%]">{item.price}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
                {!loading && (
                    <div className="mt-4">
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={(page) => setCurrentPage(page)}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default Products;
